import React from 'react';

const Root = ({ sidebarOpen = false, children }) => {
  const rootCls = `thjonustuvefur ${sidebarOpen ? ' sidebar-on sidebar-open' : ''}`;
  return (
    <div className={rootCls} style={{ position: 'relative' }}>
      <div id="main-wrap" className="main-wrap">
        <div className="top-spacer" />
        {children}
      </div>
    </div>
  );
};


export default Root;